import React, { useEffect, useState } from "react";
import { getOrderDetail } from "../../../../services/LocationService";
import { PriceDetail } from "../../../../models/Order";
import User from "../../../../models/User";
import { getUserDetail } from "../../../../services/UserService";

export default function useOrderDetail(props: { id: string; openDialog: boolean }) {
	const [userDetail, setUserDetail] = useState<User>();
	const loadOrder = async () => {
		try {
			var res = await getUserDetail(props.id);

			setUserDetail(res);
		} catch (err) {
			console.error(err);
		}
	};
	const reload = () => {
		loadOrder();
	};
	useEffect(() => {
		if (props.id && props.id != "0") {
			reload();
		}
	}, [props.id, props.openDialog]);
	return {
		userDetail,
		detailReload: reload,
	};
}
